module.exports = __webpack_public_path__ + "static/img/node_post.2941d56.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/about/tutorial/img/node_post.png
// module id = 5C1X
// module chunks = 1